module.exports = __webpack_public_path__ + "img/print_with_pictures_blue.ee13249a.svg";